<div class="dialog-top">
  <h2 mat-dialog-title>{{ 'Page preview' | translate }}</h2>
  <button mat-icon-button mat-dialog-close tabindex="-1" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <form [formGroup]="customerForm">
    <div class="cdc-form-field actif">
      <div class="cdc-label">{{ 'Select role type' | translate }}</div>
      <select formControlName="roleSelected" matNativeControl>
        <option *ngFor="let role of roleTypes" [value]="role.value">{{ role.key | translate }}</option>
      </select>
    </div>

    <div class="cdc-form-field actif">
      <div class="cdc-label">{{ 'Select customer code' | translate }}</div>

      <input matInput
             type="text"
             formControlName="customerCode"
             placeholder="Enter customer code"
             maxlength="8">
      <mat-error *ngIf="customerForm.get('customerCode')?.invalid && customerForm.get('customerCode')?.touched">
        {{ 'Customer code must be empty or exactly 8 digits' | translate }}
      </mat-error>
    </div>

    <div class="cdc-form-field actif">
      <div class="cdc-label">{{ 'Select soprod id' | translate }}</div>

      <input matInput
             type="text"
             formControlName="soprodId"
             placeholder="Enter soprod id">
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ 'Cancel' | translate }}</button>
  <button mat-button [disabled]="!customerForm.valid" (click)="onConfirm()">{{ 'Confirm' | translate }}</button>
</mat-dialog-actions>
